
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 3c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm3 10.6c.4.4.4 1 0 1.4s-1 .4-1.4 0L12 13.4 10.4 15c-.4.4-1 .5-1.4.1s-.5-1-.1-1.4l.1-.1 1.6-1.6L9 10.4c-.4-.4-.5-1-.1-1.4s1-.5 1.4-.1l.1.1 1.6 1.6L13.6 9c.4-.4 1-.4 1.4 0s.4 1 0 1.4L13.4 12l1.6 1.6z"}})])
          )
        }
      }
    